angular
  .module('countriesApp')
  .run([
    '$transitions',
    $transitions => {
      // At the end of each view transition we enforce to scroll up to the top of the page
      $transitions.onFinish({}, () => window.scrollTo(0, 0));
    }
  ])
  .run([
    'ApiService',
    Api => {
      // We inform the API service that the spinner has to be displayed for each request
      Api.always_spinner = true;
    }
  ])
  .run([
    '$rootScope',
    $rootScope => {
      /**
       * Changes the title of the page given a country Model
       *
       * @param {object} country - Country Model
       *
       * @returns {undefined}
       */
      const updateTitle = country => {
        document.title = `${ country ? country.name : 'Countries' } | Devex`;
      };

      // Event listener for updateTitle, it's fired each time we change views
      $rootScope.$on('updateTitle', (event, country) => updateTitle(country));
    }
  ]);
